import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { callOperation, actions as asyncActions } from "async-ops";
import MdaeDataGrid, { IMdaeDataGridProps } from "../data-grid";
import { GET_NOTIFICATIONS } from "./services/get-notifications";
import { isEqual } from "lodash";
import { MasterDetail } from "devextreme-react/data-grid";
import {
  TOGGLE_NOTIFICATION_GRID_SELECTION,
  defaultNotificationgridSelectionObject,
  TOGGLE_DELETE_NOTIFICATION_BUTTON,
  SET_NOTIFICATION_GRID_SELECTED_ROW_KEYS,
  TOGGLE_NOTIFICATION_AND_SYSTEM_MSG_GRID_SEARCH_PANEL,
  SET_NOTIFICATION_DATA_GRID_FILTER,
  SET_NOTIFICATION_AS_READ,
  UPDATE_NOTIFICATION_LIST,
} from "./reducers/notification-and-system-messages-reducer";
import { MARK_NOTIFICATION_AS_READ } from "./services/mark-notification-as-read";
import { MARK_NOTIFICATION_AS_SENT } from "./services/mark-notification-as-sent";
import {
  readNotificationsStorageKey,
  unsentNotificationsStorageKey,
} from "../../../app/ApplicationEventHandler";
import DOMPurify from 'dompurify';

export const updateNotificationsList = (dispatch, notificatioList) => {
  dispatch({ type: UPDATE_NOTIFICATION_LIST, data: { notificatioList } });
};
export const updateReadStatusOfNotification = (dispatch, notificationId) => {
  if (notificationId)
    dispatch({
      type: SET_NOTIFICATION_AS_READ,
      notificationId,
    });
};
const markNotificationAsSent = (notificationId) => {
  callOperation(MARK_NOTIFICATION_AS_SENT, notificationId);
};
const markNotificationAsRead = (dispatch, notificationId) => {
  var readNotificationIds = [];
  readNotificationIds.push(notificationId);
  localStorage.setItem(
    readNotificationsStorageKey,
    JSON.stringify(readNotificationIds)
  );
  callOperation(MARK_NOTIFICATION_AS_READ, notificationId);
};
const createNotification = function(dispatch, notificationData) {
  if (
    !(
      notificationData.isNotificationSent || notificationData.isNotificationRead
    )
  ) {
    var notification = new Notification(notificationData.notificationText, {
      tag: notificationData.notificationId,
      icon: "/images/ui-rewrite-icons/md-transparent.png",
    });
    if (notificationData.notificationLinkURL) {
      notification.onclick = function(event) {
        event.preventDefault();
        this.close();
        /* MARK NOTIFICATION AS READ */
        markNotificationAsRead(dispatch, notificationData.notificationId);
        updateReadStatusOfNotification(
          dispatch,
          notificationData.notificationId
        );
        window.open(notificationData.notificationLinkURL, "_blank");
      };
    }
    notification.onshow = function() {
      /* MARK NOTIFICATION AS SENT */
      markNotificationAsSent(notificationData.notificationId);
    };
  }
};
const processUnSentNotifications = function(dispatch, notifications) {
  const unsentNotifications = [];
  for (var i = 0; i < notifications.length; i++) {
    if (!notifications[i].isNotificationSent) {
      unsentNotifications.push(notifications[i]);
    }
    if (
      !(
        notifications[i].isNotificationSent ||
        notifications[i].isNotificationRead
      )
    ) {
      if (
        typeof Notification != "undefined" &&
        Notification.permission === "granted"
      )
        createNotification(dispatch, notifications[i]);
      else markNotificationAsSent(notifications[i].notificationId);
    } else if (!notifications[i].isNotificationSent)
      markNotificationAsSent(notifications[i].notificationId);
  }
  if (unsentNotifications.length > 0)
    localStorage.setItem(
      unsentNotificationsStorageKey,
      JSON.stringify(unsentNotifications)
    );
};
const processNotifications = (dispatch, notifications) => {
  if (notifications && notifications.length > 0) {
    if (
      typeof Notification != "undefined" &&
      Notification.permission !== "denied"
    ) {
      Notification.requestPermission().then(function(permission) {
        if (permission === "granted") {
          processUnSentNotifications(dispatch, notifications);
        }
      });
    } else processUnSentNotifications(dispatch, notifications);
  }
};
export const getUnsentNotifications = (dispatch) => {
  dispatch(asyncActions.asyncOperationStart(GET_NOTIFICATIONS, {}));
};

export const toggleDocumentGridCheckboxes = (
  dispatch,
  notificationGridSelection
) => {
  if (notificationGridSelection === "multiple") {
    dispatch({
      type: TOGGLE_NOTIFICATION_GRID_SELECTION,
      data: {
        notificationGridSelectionObject: {
          ...defaultNotificationgridSelectionObject,
          mode: "single",
        },
      },
    });
    dispatch({
      type: SET_NOTIFICATION_GRID_SELECTED_ROW_KEYS,
      data: { notificationGridSelectedRowKeys: [] },
    });
  } else {
    dispatch({
      type: TOGGLE_NOTIFICATION_GRID_SELECTION,
      data: {
        notificationGridSelectionObject: {
          ...defaultNotificationgridSelectionObject,
          mode: "multiple",
        },
      },
    });
  }
};
export const toggleDeleteNotificationButton = (dispatch, isVisible) => {
  dispatch({
    type: TOGGLE_DELETE_NOTIFICATION_BUTTON,
    data: {
      isDeleteNotificationBtnVisible: isVisible,
    },
  });
};
export const toggleNotificaionAndSystemMsgGridSearchPanel = (
  dispatch,
  isVisible
) => {
  dispatch({
    type: TOGGLE_NOTIFICATION_AND_SYSTEM_MSG_GRID_SEARCH_PANEL,
    data: {
      isNotificationAndSystemMessagesGridSearchPanelVisible: isVisible,
    },
  });
};
export const setNotificationsDataGridFilter = (dispatch, filter) => {
  dispatch({
    type: SET_NOTIFICATION_DATA_GRID_FILTER,
    data: {
      notificationsDataGridFilter: filter,
    },
  });
};
interface INotificationComponentProps {
  visible: boolean;
}

const NotificationComponent: React.FC<INotificationComponentProps> = (
  props
) => {
  const dispatch = useDispatch();
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: asyncActions.asyncOperationStart,
    },
    dispatch
  );
  useEffect(() => {
    asyncAction.asyncOperationStart(GET_NOTIFICATIONS);
  }, []);
  const notificationList = useSelector(
    (state) => state["notificationAndSystemMessagesReducer"].notificationList,
    isEqual
  );

  useEffect(() => {
    processNotifications(dispatch, notificationList);
  }, [notificationList]);

  const notificationGridSelection = useSelector(
    (state) =>
      state["notificationAndSystemMessagesReducer"]
        .notificationGridSelectionObject.mode,
    isEqual
  );
  const isNotificationAndSystemMessagesGridSearchPanelVisible = useSelector(
    (state) =>
      state["notificationAndSystemMessagesReducer"]
        .isNotificationAndSystemMessagesGridSearchPanelVisible,
    isEqual
  );

  const notificationsDataGridProps = useMemo(
    () =>
      getRefTaskListDataGridOptions(
        notificationGridSelection,
        toggleDeleteNotificationButton,
        dispatch,
        isNotificationAndSystemMessagesGridSearchPanelVisible
      ),
    [
      notificationGridSelection,
      isNotificationAndSystemMessagesGridSearchPanelVisible,
    ]
  );
  const NotificationDetailTemplate = ({ data }) => {
    if (!data?.isNotificationRead) {
      data.isNotificationRead = true;
      markNotificationAsRead(dispatch, data?.notificationId);
    }

    return (
      <div>
        <div
          style={{ width: "100%", whiteSpace: "normal", marginBottom: "10px" }}
          dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(data.notificationText.replace("\r", "<br/>"))}}
        />
        {data.notificationLinkURL && (
          <a
            style={{ padding: "0px", color: "blue" }}
            href={data.notificationLinkURL}
            target="_blank"
          >
            {data.notificationLinkText
              ? data.notificationLinkText
              : "Click here to see details"}
          </a>
        )}
      </div>
    );
  };
  return (
    <div
      className="notifiation-component"
      style={{ display: props.visible ? "block" : "none" }}
    >
      <MdaeDataGrid {...notificationsDataGridProps}>
        <MasterDetail render={NotificationDetailTemplate} />
      </MdaeDataGrid>
    </div>
  );
};

const getRefTaskListDataGridOptions = (
  notificationGridSelection,
  toggleDeleteNotificationButton,
  dispatch,
  isNotificationAndSystemMessagesGridSearchPanelVisible
) => {
  const sampleDataGridOption: IMdaeDataGridProps = {
    id: "pnlNotificationList",
    wordWrapEnabled: true,
    showColumnHeaders: (() =>
      notificationGridSelection === "multiple" ? true : false)(),
    searchPanel: {
      visible: isNotificationAndSystemMessagesGridSearchPanelVisible,
    },
    rowAlternationEnabled: false,
    showColumnLines: false,
    showRowLines: false,
    showBorders: false,
    sorting: { mode: "none" },
    height: (window.innerHeight * 2) / 3,
    width: 540,
    editing: {
      texts: {
        confirmDeleteMessage: "",
      },
    },
    onRowClick: function(e) {
      if (notificationGridSelection === "single") {
        var row = e.key;
        e.component.selectRows([row], false);
      }
    },
    onOptionChanged:(e) =>{
      if(e?.name === "selection" && e?.value?.mode === "multiple"){
        e.component.collapseAll(-1);
        e.component.clearSelection();
      }
    },
    onSelectionChanged: function(e) {
      const selectedRowKeys = e.component.option("selectedRowKeys");
      const selectionMode = (e.component.option(
        "selection.mode"
      ) as any)?.toLowerCase();
      if (
        selectionMode === "multiple" &&
        selectedRowKeys &&
        selectedRowKeys.length
      )
        toggleDeleteNotificationButton(dispatch, true);
      else toggleDeleteNotificationButton(dispatch, false);

      if (selectionMode !== "multiple") {
        if (e.currentDeselectedRowKeys?.length > 0)
          e.component.collapseRow(e.currentDeselectedRowKeys[0]);
        if (e.currentSelectedRowKeys?.length > 0)
          e.component.expandRow(e.currentSelectedRowKeys[0]);
      }
    },
    mdaeColumns: [
      {
        dataField: "notificationArea",
        caption: "",
        width: 50,
        allowSearch: false,
        cellRender: function(cellData) {
          var notificationArea = cellData.data.notificationArea
            ? cellData.data.notificationArea.toLowerCase()
            : "";
          var iconClassName = "";
          switch (notificationArea) {
            case "coder review":
              iconClassName = "fa fa-comment coder-review-notification-icon";
              break;
            case "qa review":
              iconClassName = "fa fa-comment qa-review-notification-icon";
              break;
            case "reports":
              iconClassName = "reports-notification-icon";
              break;
            case "audit creation":
              iconClassName = "audit-creation-notification-icon";
              break;
            case "esmd":
              iconClassName = "fa fa-paper-plane esmd-notification-icon";
                  break;
            case "payer task":
            case "external task":
              iconClassName = "external-task-notification-icon";
                break;
            default:
              iconClassName = "fa fa-bell-o other-notification-icon";
              break;
          }
          return (
            <i
              className={iconClassName}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            ></i>
          );
        },
      },
      {
        dataField: "notificationTitle",
        caption: "",
        width: 372,
        cellRender: function(cellData) {
          var textClass =
            cellData.data.isNotificationRead === true
              ? "read-message"
              : "unread-message";
          return (
            <div className={textClass}>{cellData.data?.notificationTitle}</div>
          );
        },
      },
    ],
    paging: {
      enabled: true,
    },
    pager: {
      displayMode: "compact",
      showInfo: true,
    },
    mdaeDataUpdaterConfig: [
      {
        actionType: GET_NOTIFICATIONS,
        isAsyncComplete: true,
        widgetOptionBindings: {
          dataSource: undefined,
        },
      },
      {
        actionType: SET_NOTIFICATION_AS_READ,
        reducerName: "notificationAndSystemMessagesReducer",
        widgetOptionBindings: {
          dataSource: "notificationList",
        },
      },
      {
        actionType: TOGGLE_NOTIFICATION_GRID_SELECTION,
        reducerName: "notificationAndSystemMessagesReducer",
        widgetOptionBindings: {
          selection: "notificationGridSelectionObject",
        },
      },
      {
        actionType: SET_NOTIFICATION_GRID_SELECTED_ROW_KEYS,
        reducerName: "notificationAndSystemMessagesReducer",
        widgetOptionBindings: {
          selectedRowKeys: "notificationGridSelectedRowKeys",
        },
      },
      {
        actionType: SET_NOTIFICATION_DATA_GRID_FILTER,
        reducerName: "notificationAndSystemMessagesReducer",
        widgetOptionBindings: {
          filterValue: "notificationsDataGridFilter",
        },
      },
    ],
  };
  return sampleDataGridOption;
};

export default NotificationComponent;
